import { render, staticRenderFns } from "./MovingImagesOnTextInputAnswerForm.vue?vue&type=template&id=c042350c&scoped=true&"
import script from "./MovingImagesOnTextInputAnswerForm.vue?vue&type=script&lang=js&"
export * from "./MovingImagesOnTextInputAnswerForm.vue?vue&type=script&lang=js&"
import style0 from "./MovingImagesOnTextInputAnswerForm.vue?vue&type=style&index=0&id=c042350c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c042350c",
  null
  
)

export default component.exports